import React, { useState } from 'react';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

import './AuthFormField.css';

const AuthFormField = React.forwardRef(
  ({ type, name, value, label, onChange, className }, ref) => {
    const [showPassword, setShowPassword] = useState(false);

    const hasText =
      (value !== null) & (value !== undefined) && String(value).length > 0;

    const inputType =
      type === 'password' ? (showPassword ? 'text' : 'password') : type;

    const classNames = [
      `auth-form-field-${type}-input`,
      hasText ? 'auth-input-label-float' : '',
      className,
    ].join(' ');

    return (
      <>
        {type === 'email' && (
          <div className='auth-input-container'>
            <input
              type='email'
              name={name}
              value={value}
              onChange={onChange}
              ref={ref}
              className={classNames}
              required
            />
            <label
              className={`auth-floating-label ${
                hasText ? 'auth-input-label-float' : ''
              }`}
            >
              {label}
            </label>
          </div>
        )}
        {type === 'password' && (
          <div className='auth-password-container'>
            <input
              type={inputType}
              name='password'
              value={value}
              onChange={onChange}
              required
              className={classNames}
            />
            <label
              className={`auth-floating-label ${
                hasText ? 'auth-input-label-float' : ''
              }`}
            >
              {label}
            </label>
            <button
              type='button'
              onClick={() => setShowPassword(!showPassword)}
              className='auth-password-eye-button'
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        )}
      </>
    );
  }
);

export default AuthFormField;
